export default {"src":"/_next/static/media/water-drainage.bd8c4651.svg","height":29,"width":25,"blurWidth":0,"blurHeight":0};